<template>
  <section class="contest-details section">
    <div class="gradient">
      <template v-if="details.highlight_bg_desktop?.url">
        <img
          v-if="isMobile || isLargeMobile"
          :src="
            details.highlight_bg_mobile?.url ?? details.highlight_bg_desktop.url
          "
        />

        <img
          v-else
          :src="details.highlight_bg_desktop.url"
        />
      </template>
    </div>
    <div class="inner-section">
      <div
        v-if="details.highlight"
        class="img-container"
      >
        <img
          :src="details.highlight.url"
          alt="details.highlight_title"
        />
      </div>
      <div class="txt-container">
        <h2>{{ details.highlight_title }}</h2>
        <p>
          {{ details.highlight_content }}
        </p>
        <ButtonSimple
          v-if="details.highlight_button_label"
          :label="details.highlight_button_label"
          color="white"
          @click="goToURL()"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ContestDetails } from '~/types'

const props = defineProps<{
  details: ContestDetails
}>()

const { isMobile, isLargeMobile } = useCustomMediaQuery()
const goToURL = () => {
  window.open(props.details.highlight_button_link, '_blank')?.focus()
}
</script>

<style lang="scss" scoped>
.contest-details.section {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 105px 0;
  overflow: hidden;
  background: #032874;

  @media screen and (max-width: 992px) {
    padding-top: 50px;
  }

  .gradient {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    width: 100vw;
    height: 100%;
    line-height: 0;
    background: radial-gradient(circle, rgb(13 72 168 / 1) 0%, #032874 100%);
    transform: translate(-50%, -50%);

    div {
      width: 100%;
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .inner-section {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 80px;

    @media (max-width: 700px) {
      padding: 0 2.5rem;
    }

    @media (max-width: 992px) {
      flex-direction: column;
    }

    .img-container {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      width: 30%;
      max-width: 484px;
      margin-right: 70px;

      img {
        width: 100%;
      }

      @media (max-width: 1280px) {
        width: 50%;
      }

      @media (max-width: 992px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 50px;
      }
    }

    .txt-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      h2 {
        color: #fff;
        font-family: SST;
        font-size: 30px;
        font-weight: 700;
        line-height: 40px;
        letter-spacing: 0;
        text-transform: none;
      }

      p {
        margin-top: 43px;
        color: #fff;
        font-size: 20px;
        line-height: 1.3;
      }

      .button {
        display: inline-block;
        margin-top: 43px;
      }
    }
  }
}
</style>
